import React from 'react';
import { useChannelContext } from '../../context/ChannelContext';
var UnMemoizedWindow = function (props) {
    var children = props.children, _a = props.hideOnThread, hideOnThread = _a === void 0 ? false : _a;
    var thread = useChannelContext().thread;
    // If thread is active and window should hide on thread. Return null
    if (thread && hideOnThread)
        return null;
    return React.createElement("div", { className: "str-chat__main-panel" }, children);
};
/**
 * Window - A UI component for conditionally displaying a Thread or Channel. If you want the Thread to be displayed side by side with the Channel that's also possible with the Window.
 * It's a very minimal component that might fit some usecases, and if not it's an easy to modify and rewrite component.
 */
export var Window = React.memo(UnMemoizedWindow);
